import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { AngularFirestore } from '@angular/fire/firestore';
import { AuthorizationService } from '../authorization/authorization.service';
import { LocationInterface, LocationInterfaceWithId } from '@sk/sk-interfaces';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PwaLocationsService {

  private lookupSource = new BehaviorSubject<{}>({});
  locationLookup = this.lookupSource.asObservable();
  locations: LocationInterfaceWithId[];
  locationDictionary = {};

  constructor(private af: AngularFirestore,
              private authService: AuthorizationService) {
  }

  // getLocations(): Observable<LocationInterfaceWithId[]> {
  //   return this.authService.getCurrentAuth()
  //     .pipe(
  //       switchMap(currentUser => this.af.collection('organizations').doc(currentUser.organizationId)
  //         .collection('locations').snapshotChanges()),
  //       map(actions => actions
  //         .map(a => {
  //           const data = a.payload.doc.data() as LocationInterface;
  //           const id = a.payload.doc.id;
  //           // ToDo: Workaround for location interface change. Can be removed when the database will be cleared out
  //           const companyName = a.payload.doc.data().companyName;
  //           let locationName = data.locationName;
  //           if (companyName) {
  //             locationName = companyName;
  //           }
  //           const exists = a.payload.doc.exists;
  //           return { id, exists, locationName, ...data } as LocationInterfaceWithId;
  //         })
  //       )
  //     );
  // }

  getLocation(locationId): Observable<LocationInterfaceWithId> {
    return this.authService.getCurrentAuth()
      .pipe(
        switchMap(currentUser => this.af.collection('organizations')
          .doc(currentUser.organizationId)
          .collection('locations').doc(locationId).snapshotChanges()),
        map(a => {
          const data: any = a.payload.data() as LocationInterface;
          const id = a.payload.id;
          const exists = a.payload.exists;
          return { id, exists, ...data } as LocationInterfaceWithId;
        })
      );
  }


  /**
   * Returns all locations for an Organization - used to populate the locations
   * select
   */
  // TODO: Remove the second map and build the list in the first one
  getLocations(): Observable<LocationInterfaceWithId[]> {
    return this.authService.getCurrentAuth()
      .pipe(
        switchMap(currentUser => this.af.collection('organizations').doc(currentUser.organizationId)
          .collection('locations').snapshotChanges()),
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as LocationInterface;
          const id = a.payload.doc.id;
          // ToDo: Workaround for location interface change. Can be removed when the database will be cleared out
          const companyName = a.payload.doc.data().companyName;
          let locationName = data.locationName;
          if (companyName) {
            locationName = companyName;
          }
          const exists = a.payload.doc.exists;
          return { id, exists, locationName, ...data } as LocationInterfaceWithId;
        })),
        map(list => {
          if (list.length !== 0) {
            this.buildLocationLookup(list);
            this.locations = list;
            return list;
          }
          return null;
        })
      );
  }

  getLocationSource() {
    return this.lookupSource
      .pipe(
        map(data => {
          if (Object.keys(data).length === 0) {
            this.getLocations()
              .pipe(
                take(1)
              ).subscribe();
          }
          return data;
        })
      );
  }

  buildLocationLookup(list) {
    const lookup = {};
    list.forEach(x => {
      lookup[x.id] = x;
    });
    this.locationDictionary = lookup;
    this.lookupSource.next(lookup);
  }

  getLocationList() {
    if (this.locations) {
      return this.locations.slice();
    } else {
      return null;
    }
  }

  clearData() {
    this.lookupSource.next({});
    this.locations = [];
  }


  // NGRX RELATED FUNCTIONS
  queryStateChangesLocations() {
    console.log(`RUN LOCATIONS QUERY - ${moment().format('HH:mm:ss')}`);
    return this.authService.getCurrentAuth()
      .pipe(
        switchMap(currentUser => this.af.collection('organizations').doc(currentUser.organizationId)
          .collection<LocationInterfaceWithId>('locations')
          .stateChanges()
        )
      );
  }


}
